import React, { FC } from 'react';
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
const P = Schema.attributes;

const Betrag: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading
				title="Beitrag des Vorhabens zur Steigerung von Attraktivität und Sichtbarkeit der Elektromobilität"
				description={PLATZHALTER_TEXT}
			/>

			<CreateForm
				formStruc={formStrucBetrag}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};
export default Betrag;

export const formStrucBetrag = [
	{
		fields: [P.Beitrag_Des_Vorhabens_Zu_0149460231_ektromobilitaet_Beschreibung],
		userProps: { columnToDivide: 1 },
	},
];
